import React from 'react';
import ReactDOM from 'react-dom';
import {
  IndexRoute,
  Route,
  Router,
  applyRouterMiddleware,
  browserHistory,
} from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Provider } from 'react-redux';
import useScroll from 'react-router-scroll/lib/useScroll';

// This should be done in a loader, but I couldn't get to work like favicon.
import 'file?name=_redirects!./redirects'; // eslint-disable-line
import configureStore from './configureStore';
import App from './containers/App';
import './index.css';
import Team from './containers/Team';
import TeamHeader from './containers/TeamHeader';
import Channel from './containers/Channel';
import Home from './pages/Home';
import TermsOfService from './pages/TermsOfService';
import HowToSOTU from './pages/HowToSOTU';
import MagicLink from './MagicLink';
import RequiresAuthentication from './RequiresAuthentication';
import VerifyAddToSlack from './VerifyAddToSlack';
import VerifySignInWithSlack from './VerifySignInWithSlack';
import Welcome from './containers/Welcome';
import {
  VERIFY_ADD_TO_SLACK_PATH,
  VERIFY_SIGN_IN_WITH_SLACK_PATH,
} from './constants';

// TODO replace this with a server redirect. E.g. netlify can do it once we have
// a custom domain.
if (
  window.location.protocol !== 'https:' &&
  window.location.hostname !== 'localhost'
) {
  window.location.href =
    `https:${window.location.href.substring(window.location.protocol.length)}`;
}

const initialState = { firebase: { authError: null } };
const store = configureStore(initialState, browserHistory);
const history = syncHistoryWithStore(browserHistory, store);

const root = document.getElementById('root');

ReactDOM.render((
  <Provider store={store}>
    <Router history={history} render={applyRouterMiddleware(useScroll())}>
      <Route component={App} path="/">
        <IndexRoute component={Home} noFooter noHeader />
        <Route component={MagicLink} path="/magic-link" />
        <Route component={VerifyAddToSlack} path={VERIFY_ADD_TO_SLACK_PATH} />
        <Route component={VerifySignInWithSlack} path={VERIFY_SIGN_IN_WITH_SLACK_PATH} />
        <Route component={TermsOfService} path="/terms-of-service" />
        <Route component={HowToSOTU} noHeader path="/how-to-sotu" />
        <Route
          components={{ content: RequiresAuthentication, header: TeamHeader }}
        >
          <Route component={Team} path="dashboard" />
          <Route component={Welcome} noHeader path="welcome" />
          <Route component={Channel} path="channel/:channelId" />
        </Route>
      </Route>
    </Router>
  </Provider>
), root);



/** WEBPACK FOOTER **
 ** ./src/index.jsx
 **/